import FactorsList from '../../../components/factor-list/FactorsList';
import Footer from '../../../components/mfa-verify/Footer';
import BaseForgeCustomizer from '../../base-forge';
import { isAnetUser, shouldDisplayResetAccountLink } from '../../../utils/user-utils';
export default class ChallengeFactorCustomizer extends BaseForgeCustomizer {

  private isAnetUser: boolean = isAnetUser();
  displayFooterText = this.isAnetUser;


  async shouldCustomize() {
    return this.context.formName === 'select-authenticator-authenticate';
  }

  protected forgifyController() {
    super.forgifyController();
    this.forgifyFactors();
    this.addResetAccountSection();
  }

  headerDescription = jQueryCourage('.o-form-explain').text();

  protected getFooter({ footerLink }: { footerLink: JQuery }) {
    return (
      <Footer
        text={this.footerText}
        footerLinks={footerLink}
        alwaysDisplayBackToSignIn={this.alwaysDisplayBackToLogin}
        displayResetAccountLink={shouldDisplayResetAccountLink()}
      />
    );
  }

  forgifyFactors() {
    const factors = jQueryCourage('.authenticator-verify-list');
    const forgeComponent = <FactorsList challenge oktaFactorsList={factors.find('.authenticator-row')}/>;
    this.renderForgeAndHideOktaComponent({ id: 'authenticator-verify-list', oktaComponent: factors, forgeComponent });
  }
}
